import React from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { Link } from '@reach/router';
import './../../App.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styled from 'styled-components';
import Header from '../menu/header2';
// Responsive video container using the "padding-bottom" trick.
const ResponsiveVideo = styled.div`
  position: relative;
  padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
  height: 0;
  overflow: hidden;
  max-width: 100%;
  margin: 1rem 0;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

function Blog() {
  return (
    <div>
      <Header/>
      <h1 style={{ color: 'white' }}>What is a DAO?</h1>
      <h2 style={{ color: 'white' }}>
        In this first video, on our Youtube Channel, we talk about what the future of organizations might look like.
      </h2>
      <h5 style={{ color: 'white' }}>August 16, 2023</h5>
      
      <ResponsiveVideo>
        <iframe
          src="https://www.youtube.com/embed/Ja9KF4gYEgk"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </ResponsiveVideo>
    </div>
  );
}

export default Blog;
